import {
  IDocumentKindListSelectorDialogCondition,
  instanceOfIDocumentKindListSelectorDialogCondition
} from "./IDocumentKindListSelectorDialogCondition";

export interface IMultiDocumentKindListSelectorDialogCondition extends IDocumentKindListSelectorDialogCondition {
}

export function instanceOfIMultiDocumentKindListSelectorDialogCondition(instance: any): instance is IMultiDocumentKindListSelectorDialogCondition {
  return instance
    && instanceOfIDocumentKindListSelectorDialogCondition(instance);
}
